import { useQuery } from '@tanstack/react-query'
import { fetchReapproCategoryPreview } from '../queries/reapproCategoryPreview.queries'

export const REAPPRO_CATEGORY_PREVIEW_KEY = 'reapproCategoryPreview'

export const useReapproCategoryPreview = (
  storeId: number,
  categoryId: number,
  enabled = true,
  deliveryDate?: string,
) =>
  useQuery({
    queryKey: [REAPPRO_CATEGORY_PREVIEW_KEY, storeId, categoryId, deliveryDate ?? null],
    queryFn: () => fetchReapproCategoryPreview(storeId, categoryId, deliveryDate),
    enabled,
    staleTime: 30_000,
  })
